import { Flex, Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { FileTextIcon } from 'lucide-react';
import { FC } from 'react';
import { ComplianceSuggestion } from './types';

interface FolderSuggestionsCardProps {
  suggestions: ComplianceSuggestion[];
}

/**
 * Amber/warning card listing folder-level compliance suggestions for the agent
 * (e.g. "Missing lead based paint addenda"). Renders nothing when there are no
 * suggestions. Read-only: there is intentionally no ignore/hide action in this
 * phase.
 */
export const FolderSuggestionsCard: FC<FolderSuggestionsCardProps> = ({
  suggestions,
}) => {
  if (suggestions.length === 0) {
    return null;
  }

  const heading =
    suggestions.length === 1
      ? '1 folder suggestion'
      : `${suggestions.length} folder suggestions`;

  return (
    <VStack
      align="stretch"
      bg="compliance.validation.warning.bg"
      borderColor="compliance.validation.warning.border"
      borderRadius="md"
      borderWidth={1}
      p={4}
      spacing={2}
    >
      <Heading
        color="compliance.status.warning"
        fontSize="md"
        fontWeight="semibold"
        size="headline"
      >
        {heading}
      </Heading>

      <VStack align="stretch" spacing={2}>
        {suggestions.map((suggestion, index) => (
          <Flex
            key={suggestion.ruleUuid ?? `folder-suggestion-${index}`}
            align="flex-start"
            gap={2}
          >
            <Icon
              as={FileTextIcon}
              boxSize="20px"
              color="compliance.status.warning"
              flexShrink={0}
              mt="2px"
            />
            <Text color="compliance.text.primary" fontSize="sm">
              {suggestion.message}
            </Text>
          </Flex>
        ))}
      </VStack>
    </VStack>
  );
};
